import React from "react";
import { useTranslation } from "react-i18next";
import Banner from "../components/Banner";
import Section1 from "../components/rand/Section1";
import Section2 from "../components/rand/Section2";
import Section3 from "../components/rand/Section3";
import Section4 from "../components/rand/Section4";
import Section5 from "../components/rand/Section5";

const Rand = () => {
  const { t } = useTranslation();

  const bannerData = {
    title: t("rnd.title"),
    img: "/images/rand/rand.jpg",
  };

  return (
    <div>
      <div className="grid grid-cols-10 pb-28">
        <div className="col-start-2 md:col-start-2 col-span-8 ">
          <Banner bannerData={bannerData} />

          <Section1 />
          <Section2 />
        </div>
      </div>

      <Section3 />
      <Section4 />

      <div className="h-px w-full bg-customGray5 my-14"></div>

      <Section5 />
    </div>
  );
};

export default Rand;
